import { countries } from './countries';

export type Country = {
  name: string;
  alpha2: string;
  alpha3: string;
  emoji: string | undefined;
  status: string;
};

export const getCountries = (): Country[] => {
  return countries
    .map((x) => {
      return {
        name: x.name,
        alpha2: x.alpha2,
        alpha3: x.alpha3,
        emoji: x.emoji,
        status: x.status,
      };
    })
    .filter((x) => x.status === 'assigned')
    .sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
};

export const getCountryNames = (): string[] => {
  return countries
    .filter((x) => x.status === 'assigned')
    .flatMap((x) => x.name)
    .sort((a, b) => {
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    });
};

export const toCountry = (countryCode: unknown): Country | undefined => {
  if (typeof countryCode !== 'string') return undefined;
  const countries = getCountries();
  return (
    countries.find((x) => x.alpha3 === countryCode) ??
    countries.find((x) => x.alpha2 === countryCode) ??
    countries.find((x) => x.name === countryCode)
  );
};
